var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoOrigoIsoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210.92 210.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{fill:#fff;}.cls-1{opacity:0.8;}.cls-2{opacity:0.2;}.cls-3{opacity:0.4;}.cls-4{opacity:0.5;}.cls-5{opacity:0.7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.74,179.91h0a13.39,13.39,0,0,1-19,0l-18.13-18.12a13.41,13.41,0,0,1-3.92-9.44h0a13.4,13.4,0,0,1,22.87-9.51L180.74,161A13.4,13.4,0,0,1,180.74,179.91Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.39,
    y1: 137.5,
    x2: 92.46,
    y2: 137.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.62,71.19h0a13.37,13.37,0,0,1-9.48-3.93L31,49.13a13.4,13.4,0,0,1,0-19h0a13.4,13.4,0,0,1,19,0L68.09,48.31A13.4,13.4,0,0,1,58.62,71.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.62,57.76l0-44.37A13.39,13.39,0,0,1,105.05,0h0a13.4,13.4,0,0,1,13.4,13.4V57.77a13.4,13.4,0,0,1-13.4,13.4h0A13.4,13.4,0,0,1,91.62,57.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 119.45,
    y: 42.63,
    width: 70.86,
    height: 26.83,
    rx: 13.4,
    transform: "translate(5.73 125.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 139.66,
    y: 92.46,
    width: 71.26,
    height: 26.81,
    rx: 13.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M106,210.92h-.26a13.27,13.27,0,0,1-13.27-13.27V137.44L49.87,180a13.28,13.28,0,0,1-18.77,0l-.2-.21a13.26,13.26,0,0,1,0-18.77l42.58-42.58H13.27A13.28,13.28,0,0,1,0,105.19v-.26A13.28,13.28,0,0,1,13.27,91.65h92.66a13.28,13.28,0,0,1,9.39,3.89h0a13.29,13.29,0,0,1,3.88,9.38l.06,92.72A13.28,13.28,0,0,1,106,210.92Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOrigoIsoWhite);
export default __webpack_public_path__ + "static/media/logo-Origo-Iso-White.11866817a745005ee20ba85aeed2e5bd.svg";
export { ForwardRef as ReactComponent };